export const OAUTH_PROVIDER_ROUTES = {
    qbo: {
        webCallbackPath: '/qbo-integration/oauth-callback',
        androidSchemeHost: 'qbo-integration'
    },
    xero: {
        webCallbackPath: '/xero-integration/oauth-callback',
        androidSchemeHost: 'xero-integration'
    }
};
export const OAUTH_PROVIDERS = Object.keys(OAUTH_PROVIDER_ROUTES);
export const ANDROID_SCHEME_CALLBACK_PATH = '/oauth-callback';
export const ALLOWED_HOSTS = [
    'demo.anchor-hq.io',
    'app.sayanchor.com'
];
export const ALLOWED_ANDROID_CALLBACK_SCHEMES = [
    'com.sayanchor.app',
    'com.sayanchor.app.staging'
];
export const OAUTH_CALLBACK_PATHS = OAUTH_PROVIDERS.map((provider)=>OAUTH_PROVIDER_ROUTES[provider].webCallbackPath);
export const webCallbackPathToProvider = (pathname)=>{
    var _OAUTH_PROVIDERS_find;
    return (_OAUTH_PROVIDERS_find = OAUTH_PROVIDERS.find((provider)=>OAUTH_PROVIDER_ROUTES[provider].webCallbackPath === pathname)) !== null && _OAUTH_PROVIDERS_find !== void 0 ? _OAUTH_PROVIDERS_find : null;
};
export const androidSchemeHostToProvider = (host)=>{
    var _OAUTH_PROVIDERS_find;
    return (_OAUTH_PROVIDERS_find = OAUTH_PROVIDERS.find((provider)=>OAUTH_PROVIDER_ROUTES[provider].androidSchemeHost === host)) !== null && _OAUTH_PROVIDERS_find !== void 0 ? _OAUTH_PROVIDERS_find : null;
};
export const androidCallbackHost = (provider)=>OAUTH_PROVIDER_ROUTES[provider].androidSchemeHost;
